export const access = 'کاربر گرامی شما مجاز به استفاده از این امکان نیستید .'